import React from 'react'
import logo from "../assets/images/DanaliLogo.svg"

const SiteLogo = () => {
    return (
        <img src={logo} style={{ width: "135px" }} />
    )
}

export default SiteLogo